import { OrgSettings } from '@sdk/authentication/types/OrganisationType';
import { OrgSettingsToApi } from '@sdk/authentication/types/apiTypes';

const preSaveUserOrgSettingsHandler = (userOrgSettings: OrgSettings): OrgSettingsToApi => {
  const updatedUserOrgSettings: OrgSettingsToApi = {
    ...userOrgSettings,
    clockInEarlyMinutes: Number(userOrgSettings.clockInEarlyMinutes),
  };

  return updatedUserOrgSettings;
};

export default preSaveUserOrgSettingsHandler;
